export const PopupStatusProfilePage = {
  INACTIVE: 'INACTIVE',
  SEND_MESSAGE: 'SEND_MESSAGE',
  UPDATE_ROLE: 'UPDATE_ROLE',
  EDIT_PROFILE: 'EDIT_PROFILE',
  LEAVE_TEAM: 'LEAVE_TEAM',
  WARNING_ONE_MANAGER: 'WARNING_ONE_MANAGER',
  WARNING_LEAVE_MANAGER: 'WARNING_LEAVE_MANAGER',
};
